import React, { useRef } from "react";
import { Link } from "gatsby";

import Layout from "../components/v2/layout";
import SEO from "../components/seo";
import Stores from "../components/stores";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import CarouselTestimonials from "../components/carouselTestimonials";
import FormPrime from "../components/formPrime";

import Button from "react-bootstrap/Button";
import { StaticImage } from "gatsby-plugin-image";
const DemoPage = () => {
  return (
    <Layout>
      <style type="text/css">
        {`
          .col-center {
            display: flex;
          }

        `}
      </style>
      <SEO title="Home" />
      <div
        style={{
          background: "radial-gradient(#b0d89d,#85c442, #507628,#231f20)",
        }}
      >
        <Container fluid className="titular">
          <Row style={{ paddingRight: "5%", paddingLeft: "5%", margin: "0" }}>
            <Col className="col-center">
              <div className="top-of-page-image">
                Préstamos personales de hasta $20,000 con 100% de aprobación. *
              </div>
            </Col>
            <Col xs={12} sm={4} className="col-center">
              <div className="highImg">
                <StaticImage
                  src="../images/v2/Top image/Prestamo Personal/1x/Chica top grismdpi.png"
                  layout="constrained"
                  alt="Principal"
                  height={260}
                />
              </div>
              <div className="lowImg" style={{ margin: "auto" }}>
                <StaticImage
                  src="../images/v2/Top image/Prestamo Personal/1x/Chica top grismdpi.png"
                  layout="constrained"
                  height={200}
                  alt="Principal"
                />
              </div>
            </Col>
            <Col className="col-center">
              <div className="top-of-page-image">
                Obtén una línea de crédito personal sin buró, anualidad,
                comprobante de ingresos, o cuenta bancaria.
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="container-benefits">
        <div className="main-heading">
          ¿Qué harías con una línea de crédito para préstamos personales?
        </div>
        <div className="general-text" style={{ textAlign: "center" }}>
          Con la membresía Casham Prime comienza o mejora tu historial
          crediticio ante las instituciones de información crediticia como
          Círculo y Buró de Crédito. Un buen historial crediticio te permite
          obtener financiamiento siempre que lo necesites.
        </div>
        <div className="secondary-headings" style={{ textAlign: "left" }}>
          Tus beneficios por ser Cashamer Prime:
        </div>
        <div style={{ margin: "auto" }}>
          <Container fluid>
            <Row>
              <Col style={{ textAlign: "center" }} xs={12} sm={6}>
                <div className="highImg">
                  <StaticImage
                    src="../images/v2/Benefits/1x/Una lineamdpi.png"
                    layout="constrained"
                    alt="Una línea garantizada"
                  />
                </div>
                <div className="lowImg">
                  <StaticImage
                    src="../images/v2/Benefits/1x/Una lineamdpi.png"
                    layout="constrained"
                    height={280}
                    alt="Una línea garantizada"
                  />
                </div>
              </Col>
              <Col style={{ margin: "auto" }}>
                <div
                  className="secondary-headings"
                  style={{ textAlign: "left" }}
                >
                  Una línea de{" "}
                  <span className="secondary-headings-emphasized">crédito</span>{" "}
                  personal{" "}
                  <span className="secondary-headings-emphasized">
                    garantizada
                  </span>
                  con tasa{" "}
                  <span className="secondary-headings-emphasized">
                    preferente
                  </span>
                  .
                </div>
                <div className="general-text" style={{ textAlign: "left" }}>
                  ¡Usa tu línea cuando quieras y para lo que quieras!
                </div>
              </Col>
            </Row>
            <Row className="invertTable">
              <Col style={{ margin: "auto" }} xs={12} sm={6}>
                <div
                  className="secondary-headings"
                  style={{ textAlign: "left" }}
                >
                  <span className="secondary-headings-emphasized">
                    Incrementos frecuentes
                  </span>{" "}
                  a tu línea de crédito.
                </div>
                <div className="general-text" style={{ textAlign: "left" }}>
                  Ofrecemos líneas de hasta $20,000. <br></br>
                  Además, con el uso responsable tu tasa mejora constantemente.
                </div>
              </Col>
              <Col style={{ textAlign: "center" }}>
                <div className="highImg">
                  <StaticImage
                    src="../images/v2/Benefits/1x/Incrementos.png"
                    alt="Líneas de hasta $20,000"
                  />
                </div>
                <div className="lowImg">
                  <StaticImage
                    src="../images/v2/Benefits/1x/Incrementos.png"
                    height={280}
                    alt="Líneas de hasta $20,000"
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col style={{ textAlign: "center" }} xs={12} sm={6}>
                <StaticImage
                  src="../images/v2/Benefits/1x/Mejoramdpi.png"
                  alt="Mejora tu perfil"
                />
              </Col>
              <Col style={{ margin: "auto" }}>
                <div
                  className="secondary-headings"
                  style={{ textAlign: "left" }}
                >
                  <span className="secondary-headings-emphasized">
                    Comienza o mejora tu perfil
                  </span>{" "}
                  crediticio en Círculo y Buró de Crédito.
                </div>
                <div className="general-text" style={{ textAlign: "left" }}>
                  Así podrás acceder a más opciones financieras. Incluso con
                  otras empresas y bancos.
                </div>
              </Col>
            </Row>
            <Row className="invertTable">
              <Col style={{ margin: "auto" }} xs={12} sm={6}>
                <div
                  className="secondary-headings"
                  style={{ textAlign: "left" }}
                >
                  <span className="secondary-headings-emphasized">
                    Ahorra miles de $${" "}
                  </span>{" "}
                  al año con la red de descuentos.
                </div>
                <div className="general-text" style={{ textAlign: "left" }}>
                  Desquita tu membresía con descuentos en muchos de los
                  comercios que visitas cotidianamente. ¡Son más de 9,000!
                </div>
              </Col>
              <Col style={{ textAlign: "center" }}>
                <StaticImage
                  src="../images/v2/Benefits/1x/Ahorramdpi.png"
                  alt="Ahorra"
                />
              </Col>
            </Row>
            <Row>
              <Col style={{ textAlign: "center" }} xs={12} sm={6}>
                <StaticImage
                  src="../images/v2/Benefits/1x/Invitamdpi.png"
                  alt="Invita a 5 personas"
                />
              </Col>
              <Col style={{ margin: "auto" }}>
                <div
                  className="secondary-headings"
                  style={{ textAlign: "left" }}
                >
                  <span className="secondary-headings-emphasized">
                    Invita a 5 personas{" "}
                  </span>{" "}
                  para que tengan su propia línea de crédito.
                </div>
                <div className="general-text" style={{ textAlign: "left" }}>
                  Puedes invitar a quien tú quieras -sin costo alguno para ti o
                  para ellos- y tendrán su propia línea de crédito. No necesitan
                  buró o cuenta de banco. ¡Sólo necesitan tu invitación!
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <CarouselTestimonials></CarouselTestimonials>

      <div className="container-benefits" style={{ marginTop: "3rem" }}>
        <div
          className="secondary-headings"
          style={{ textAlign: "center", marginTop: "3rem" }}
        >
          ¿Aún tienes dudas? Prueba Prime sin riesgo alguno durante 30 días. *
        </div>
      </div>
      <FormPrime campaign="prestamo-personal"></FormPrime>
      <div className="general-text" style={{ textAlign: "left", marginTop: "2rem"}}>
        La membresía requiere del pago de una cuota única de {" "}$750.00 mas IVA,
        <span className="general-text-emphasized">nunca volverás a pagar cuota o anualidad alguna</span> y podrás pedir tu
        primer préstamo <span className="general-text-emphasized">inmediatamente</span>. *
      </div>
      <div className="container-benefits">
        <div
          className="secondary-headings"
          style={{ textAlign: "left", marginTop: "2rem" }}
        >
          Nuestro Manifiesto de servicio.
        </div>
        <div className="general-text" style={{ textAlign: "left" }}>
          <span className="general-text-emphasized">SIEMPRE</span> te trataremos
          con absoluto respeto, cuidaremos tu privacidad y trataremos de
          ayudarte, incluso cuando tengas retrasos en tus pagos.{" "}
          <span className="general-text-emphasized">NUNCA</span> espiaremos lo
          que haces en tu celular, ni contactaremos a tus conocidos.
        </div>
        <div
          className="secondary-headings"
          style={{ textAlign: "center", marginTop: "3rem" }}
        >
          ¿Cuándo comenzarás a mejorar tus finanzas? Déjate de pretextos y ¡Sé Cashamer!
        </div>
      </div>
    </Layout>
  );
};

export default DemoPage;
